<script setup lang="ts">
defineProps<{
  name:
    | "search"
    | "add"
    | "minus"
    | "expand_more"
    | "edit"
    | "upload"
    | "checkmark"
    | "check"
    | "home"
    | "checklist"
    | "briefcase"
    | "user-circle"
    | "bolt"
    | "settings"
    | "help"
    | "close"
    | "logout"
    | "person_add"
    | "chevron_left"
    | "chevron_right"
    | "chevron-down"
    | "search-area"
    | "to-dos"
    | "layout-left"
    | "layout-left-off"
    | "layout-right"
    | "list"
    | "grid"
    | "refresh"
    | "loop"
    | "filter"
    | "sort"
    | "columns"
    | "download"
    | "pin"
    | "more_vert"
    | "file-user"
    | "calendar-check"
    | "phone-check"
    | "list-bullet"
    | "grid-view"
    | "sort-desc"
    | "layout-columns"
    | "download-icon"
    | "sparkles"
    | "sparkles-2"
    | "upload-cloud"
    | "archive"
    | "unarchive"
    | "copy"
    | "notebook"
    | "message-dots"
    | "calendar-clock"
    | "send"
    | "phone-call"
    | "phone-hangup"
    | "people"
    | "file-text"
    | "circle-dotted"
    | "check-circle"
    | "archive-arrow-down"
    | "archive-arrow-up"
    | "cloud-upload"
    | "link"
    | "pencil"
    | "arrow-right"
    | "arrow-left"
    | "hashtag"
    | "play"
    | "play-solid"
    | "rocket"
    | "alert-circle"
    | "x-circle"
    | "trash-2"
    | "message-square"
    | "double-chevron-right"
    | "matched"
    | "screened"
    | "interviewed"
    | "user-circle-check"
    | "users"
    | "person-check"
    | "person-cross"
    | "users-plus"
    | "user-cross"
    | "ellipsis-horizontal"
    | "maximize"
    | "plus"
    | "translate"
    | "chart-increase"
    | "folder-star";
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}>();
</script>

<template>
  <div
    class="icon-atom"
    :style="{ width: `${size || 24}px`, height: `${size || 24}px` }"
  >
    <!-- Notebook Icon -->
    <svg
      v-if="name === 'notebook'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 7H17"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 12H17"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 17H13"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Message Dots Icon -->
    <svg
      v-else-if="name === 'message-dots'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11.5C21 16.1944 16.9706 20 12 20C10.8524 20 9.75239 19.8037 8.72979 19.4429L3 21L4.57021 15.2702C3.57021 14.1687 3 12.8797 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 13H12.01"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 13H16.01"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 13H8.01"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Calendar Clock Icon -->
    <svg
      v-else-if="name === 'calendar-clock'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H13"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 15V6C21 4.89543 20.1046 4 19 4"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 2V6"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 2V6"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 10H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="17"
        cy="17"
        r="5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
      />
      <path
        d="M17 15V17L18.5 18.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Send Icon -->
    <svg
      v-else-if="name === 'send'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2L11 13"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Phone Call Icon -->
    <svg
      v-else-if="name === 'phone-call'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 16.92V19.92C22.0011 20.1986 21.9441 20.4742 21.8325 20.7294C21.7209 20.9846 21.5573 21.2137 21.3521 21.402C21.1468 21.5902 20.9046 21.7336 20.6407 21.8228C20.3769 21.912 20.0974 21.9452 19.82 21.92C16.7428 21.5857 13.787 20.5342 11.19 18.84C8.77382 17.2481 6.72533 15.2003 5.13 12.78C3.42222 10.1733 2.36882 7.20789 2.04 4.13003C2.01488 3.85334 2.04798 3.57463 2.1371 3.3115C2.22622 3.04837 2.36942 2.80673 2.55736 2.60227C2.7453 2.39781 2.97378 2.23511 3.22822 2.12461C3.48266 2.01411 3.75738 1.95828 4.035 1.96003H7.03C7.5637 1.95734 8.07593 2.16653 8.4569 2.54276C8.83787 2.91898 9.0572 3.43199 9.068 3.97103C9.07833 4.6972 9.25337 5.41332 9.58 6.07003C9.70935 6.32758 9.73741 6.62112 9.66041 6.89711C9.5834 7.17311 9.40656 7.41303 9.162 7.57303L7.89 8.84003C9.31278 11.3418 11.4082 13.4373 13.91 14.86L15.18 13.59C15.3393 13.3445 15.5791 13.1668 15.8551 13.0893C16.1312 13.0118 16.425 13.0393 16.683 13.168C17.3413 13.4956 18.0593 13.671 18.787 13.68C19.3271 13.6902 19.8413 13.9095 20.2182 14.2908C20.5951 14.672 20.8047 15.1852 20.802 15.72V16.92H22Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Phone Hangup Icon -->
    <svg
      v-else-if="name === 'phone-hangup'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.68 13.31L13.23 15.86C13.5358 15.5539 13.9079 15.3401 14.3168 15.2359C14.7258 15.1317 15.1607 15.1401 15.587 15.2606L17.587 15.832C17.9892 15.947 18.3371 16.2115 18.5663 16.576C18.7954 16.9405 18.89 17.3797 18.832 17.812L18.421 20.849C18.3695 21.2292 18.1726 21.5779 17.8647 21.8325C17.5568 22.0872 17.1581 22.2311 16.74 22.231C14.2259 22.2106 11.7801 21.4326 9.68999 19.989C7.42674 18.4419 5.60339 16.3409 4.39999 13.929C3.26622 11.4925 2.87274 8.76182 3.27999 6.12103C3.33534 5.76077 3.5159 5.43343 3.78912 5.19794C4.06233 4.96245 4.41031 4.83416 4.77099 4.83603L7.74799 4.97203C8.17025 4.99127 8.57143 5.20235 8.86299 5.55903C9.15456 5.91572 9.31293 6.38927 9.30399 6.87603L9.19899 9.07603C9.1764 9.49757 9.27896 9.91741 9.48999 10.269C9.70102 10.6206 10.0084 10.8842 10.363 11.018"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 2L2 22"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- People Icon -->
    <svg
      v-else-if="name === 'people'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 20V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V20"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23 20V19C22.9993 17.1132 21.7044 15.464 19.872 14.9"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 3.13C17.827 3.69705 19.1102 5.34481 19.1135 7.27C19.1129 9.19572 17.8292 10.844 16.002 11.41"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Home Icon (24px) -->
    <svg
      v-else-if="name === 'home'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 9.5L12 3.5L19.5 9.5V20.5H15.5V14.5H8.5V20.5H4.5V9.5Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- To-dos/Checklist Icon -->
    <svg
      v-else-if="name === 'to-dos'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.75"
        y="5.75"
        width="4.5"
        height="4.5"
        rx="0.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
      />
      <rect
        x="5.75"
        y="13.75"
        width="4.5"
        height="4.5"
        rx="0.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
      />
      <path
        d="M13.75 7.5H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M13.75 15.5H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M13.75 9.5H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M13.75 17.5H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.5 13L8.5 14L9.5 13"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Search Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'search'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 19.25L15.5 15.5M4.75 11C4.75 9.3424 5.40848 7.75268 6.58058 6.58058C7.75268 5.40848 9.3424 4.75 11 4.75C12.6576 4.75 14.2473 5.40848 15.4194 6.58058C16.5915 7.75268 17.25 9.3424 17.25 11C17.25 12.6576 16.5915 14.2473 15.4194 15.4194C14.2473 16.5915 12.6576 17.25 11 17.25C9.3424 17.25 7.75268 16.5915 6.58058 15.4194C5.40848 14.2473 4.75 12.6576 4.75 11Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Briefcase/Jobs Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'briefcase'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 9.75C4.75 8.64543 5.64543 7.75 6.75 7.75H17.25C18.3546 7.75 19.25 8.64543 19.25 9.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V9.75Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 18.75V6.75C8.75 5.64543 9.64543 4.75 10.75 4.75H13.25C14.3546 4.75 15.25 5.64543 15.25 6.75V18.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- User Circle/Candidates Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'user-circle'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 10C14.25 11.2426 13.2426 12.25 12 12.25C10.7574 12.25 9.75 11.2426 9.75 10C9.75 8.75736 10.7574 7.75 12 7.75C13.2426 7.75 14.25 8.75736 14.25 10Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.19745 17C8.34392 15.625 10.0698 14.75 12 14.75C13.9302 14.75 15.6561 15.625 16.8025 17"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Bolt/Automations Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'bolt'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 13.25H6.75L13.25 4.75V10.75H17.25L10.75 19.25V13.25Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Settings Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'settings'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.62117 14.9627L6.72197 15.1351C7.53458 15.2623 8.11491 16.0066 8.05506 16.8451L7.97396 17.9816C7.95034 18.3127 8.12672 18.6244 8.41885 18.7686L9.23303 19.1697C9.52516 19.3139 9.87399 19.2599 10.1126 19.0352L10.9307 18.262C11.5339 17.6917 12.4646 17.6917 13.0685 18.262L13.8866 19.0352C14.1252 19.2608 14.4733 19.3139 14.7662 19.1697L15.5819 18.7678C15.8733 18.6244 16.0489 18.3135 16.0253 17.9833L15.9441 16.8451C15.8843 16.0066 16.4646 15.2623 17.2772 15.1351L18.378 14.9627C18.6985 14.9128 18.9568 14.6671 19.0292 14.3433L19.23 13.4428C19.3025 13.119 19.1741 12.7831 18.9064 12.5962L17.9875 11.9526C17.3095 11.4774 17.1024 10.5495 17.5119 9.82051L18.067 8.83299C18.2284 8.54543 18.2017 8.18538 17.9993 7.92602L17.4363 7.2035C17.2339 6.94413 16.8969 6.83701 16.5867 6.93447L15.5221 7.26794C14.7355 7.51441 13.8969 7.1012 13.5945 6.31908L13.1866 5.26148C13.0669 4.95218 12.7748 4.7492 12.4496 4.75L11.5472 4.75242C11.222 4.75322 10.9307 4.95782 10.8126 5.26793L10.4149 6.31344C10.1157 7.1004 9.27319 7.51683 8.4842 7.26874L7.37553 6.92078C7.0645 6.82251 6.72591 6.93044 6.52355 7.19142L5.96448 7.91474C5.76212 8.17652 5.73771 8.53738 5.90228 8.82493L6.47 9.81487C6.88812 10.5446 6.68339 11.4814 6.00149 11.9591L5.0936 12.5954C4.82588 12.7831 4.69754 13.119 4.76998 13.442L4.97077 14.3425C5.04242 14.6671 5.30069 14.9128 5.62117 14.9627Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5911 10.4089C14.4696 11.2875 14.4696 12.7125 13.5911 13.5911C12.7125 14.4696 11.2875 14.4696 10.4089 13.5911C9.53036 12.7125 9.53036 11.2875 10.4089 10.4089C11.2875 9.53036 12.7125 9.53036 13.5911 10.4089Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Help Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'help'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 10C9.75 10 10 7.75 12 7.75C14 7.75 14.25 9 14.25 10C14.25 10.7513 13.8266 11.5027 12.9798 11.8299C12.4647 12.0289 12 12.4477 12 13V13.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z"
        :stroke="color || 'currentColor'"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Search Area/Hunting-agents Icon -->
    <svg
      v-else-if="name === 'search-area'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5 14.5L17.25 17.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 8.25V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H8.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 15.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H8.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.25 8.25V6.75C19.25 5.64543 18.3546 4.75 17.25 4.75H15.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Checklist Icon -->
    <svg
      v-else-if="name === 'checklist'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25 9.25V6.75C9.25 6.19772 8.80228 5.75 8.25 5.75H5.75C5.19772 5.75 4.75 6.19772 4.75 6.75V9.25C4.75 9.80228 5.19772 10.25 5.75 10.25H8.25C8.80228 10.25 9.25 9.80228 9.25 9.25Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25 18.25H5.75C5.19772 18.25 4.75 17.8023 4.75 17.25V13.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.75 6.75H19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.75 14.75H19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.75 9.25H19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.75 17.25H19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.25 12.75C10.25 12.75 8.75 14.375 8 16.25L6.75 14.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Chevron Left Icon -->
    <svg
      v-else-if="name === 'chevron_left'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8L11 12L15 16"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Chevron Right Icon -->
    <svg
      v-else-if="name === 'chevron_right'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 8L13 12L9 16"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Expand More/Chevron Down -->
    <svg
      v-else-if="name === 'expand_more'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10L12 15L17 10"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Add/Plus Icon -->
    <svg
      v-else-if="name === 'add'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.75V18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M5.75 12H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- Minus Icon (Indeterminate) -->
    <svg
      v-else-if="name === 'minus'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 12H18.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- Close Icon -->
    <svg
      v-else-if="name === 'close'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L7 17"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7 7L17 17"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- Person Add Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'person_add'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 19.5V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V19.5"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 8V14"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 11H16"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Logout Icon (Updated to match Icons.vue) -->
    <svg
      v-else-if="name === 'logout'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.077 23.3333C2.40344 23.3333 1.83333 23.1 1.36667 22.6333C0.9 22.1667 0.666667 21.5966 0.666667 20.9231V3.077C0.666667 2.40344 0.9 1.83333 1.36667 1.36667C1.83333 0.9 2.40344 0.666667 3.077 0.666667H11.013C11.2966 0.666667 11.5341 0.762444 11.7257 0.954C11.917 1.14533 12.0127 1.38289 12.0127 1.66667C12.0127 1.95044 11.917 2.188 11.7257 2.37933C11.5341 2.57089 11.2966 2.66667 11.013 2.66667H3.077C2.97433 2.66667 2.88033 2.70944 2.795 2.795C2.70944 2.88033 2.66667 2.97433 2.66667 3.077V20.9231C2.66667 21.0256 2.70944 21.1197 2.795 21.2051C2.88033 21.2906 2.97433 21.3333 3.077 21.3333H11.013C11.2966 21.3333 11.5341 21.4291 11.7257 21.6207C11.917 21.812 12.0127 22.0496 12.0127 22.3333C12.0127 22.6171 11.917 22.8547 11.7257 23.046C11.5341 23.2376 11.2966 23.3333 11.013 23.3333H3.077ZM19.4897 13H9.12833C8.84456 13 8.60689 12.9042 8.41533 12.7127C8.224 12.5213 8.12833 12.2838 8.12833 12C8.12833 11.7162 8.224 11.4787 8.41533 11.2873C8.60689 11.0958 8.84456 11 9.12833 11H19.4897L16.9257 8.436C16.7411 8.25133 16.6465 8.02611 16.6424 7.76033C16.6381 7.49456 16.7325 7.25822 16.9257 7.05133C17.1188 6.84444 17.3531 6.73756 17.6284 6.73067C17.9035 6.724 18.1444 6.824 18.3513 7.03067L22.4771 11.1563C22.7179 11.3974 22.8384 11.6787 22.8384 12C22.8384 12.3213 22.7179 12.6026 22.4771 12.8437L18.3513 16.9693C18.1531 17.1676 17.9177 17.2653 17.6451 17.2627C17.3724 17.2602 17.1325 17.1556 16.9257 16.9487C16.7325 16.7418 16.6394 16.5043 16.6464 16.236C16.6531 15.9676 16.7531 15.7368 16.9464 15.5437L19.4897 13Z"
        :fill="color || 'currentColor'"
      />
    </svg>

    <!-- Upload Cloud Icon (New Design) -->
    <svg
      v-else-if="name === 'upload-cloud'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 14.75H16.25C17.9069 14.75 19.25 16.0931 19.25 17.75C19.25 19.4069 17.9069 20.75 16.25 20.75H7.75C6.09315 20.75 4.75 19.4069 4.75 17.75C4.75 16.0931 6.09315 14.75 7.75 14.75H8.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15.75V3.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.25 6.5L12 3.25L8.75 6.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Edit Icon -->
    <svg
      v-else-if="name === 'edit'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 17.25L17.25 7L16.75 6.5L6.5 16.75L7 17.25Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 3L21 8L8 21H3V16L16 3Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Upload Icon -->
    <svg
      v-else-if="name === 'upload'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 14.75V16.25C4.75 17.9069 6.09315 19.25 7.75 19.25H16.25C17.9069 19.25 19.25 17.9069 19.25 16.25V14.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12 14.25V5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M8.75 8.25L12 4.75L15.25 8.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- File Text Icon -->
    <svg
      v-else-if="name === 'file-text'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 2V8H20"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 13H8"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 17H8"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 9H8"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- Check Icon (Same as Checkmark) -->
    <svg
      v-else-if="name === 'check' || name === 'checkmark'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6L9 17L4 12"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Layout Left (Sidebar Collapse) -->
    <svg
      v-else-if="name === 'layout-left'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.75"
        y="4.75"
        width="14.5"
        height="14.5"
        rx="1.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
      />
      <path
        d="M8.25 7.75V16.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- Layout Left Off (Sidebar Expand) -->
    <svg
      v-else-if="name === 'layout-left-off'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.75"
        y="4.75"
        width="14.5"
        height="14.5"
        rx="1.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
      />
      <path
        d="M15.75 7.75V16.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>

    <!-- List Icon (Design: list-bullet) -->
    <svg
      v-else-if="name === 'list' || name === 'list-bullet'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 18H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 6H3.01"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 12H3.01"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 18H3.01"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Grid Icon (Design: grid-view) -->
    <svg
      v-else-if="name === 'grid' || name === 'grid-view'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Refresh Icon -->
    <svg
      v-else-if="name === 'refresh'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.151 17.5348 17.7725"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 12C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84896 6.46519 6.22754"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 12V6"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 12V18"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Loop Icon (lucide-refresh-cw) -->
    <svg
      v-else-if="name === 'loop'"
      viewBox="-6 -6 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 3v5h-5"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 16H3v5"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Filter Icon -->
    <svg
      v-else-if="name === 'filter'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Sort Descending Icon -->
    <svg
      v-else-if="name === 'sort' || name === 'sort-desc'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 12H15"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 18H9"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Columns Icon (Layout Columns) -->
    <svg
      v-else-if="name === 'columns' || name === 'layout-columns'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3H3V21H10V3Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 3H14V21H21V3Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Download Icon (Download) -->
    <svg
      v-else-if="name === 'download' || name === 'download-icon'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 10L12 15L17 10"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15V3"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Pin Icon -->
    <svg
      v-else-if="name === 'pin'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- More Vert Icon -->
    <svg
      v-else-if="name === 'more_vert'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        :stroke="color || 'currentColor'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- File User Icon -->
    <svg
      v-else-if="name === 'file-user'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 2V8H20"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 18C14.2091 18 16 16.2091 16 14C16 11.7909 14.2091 10 12 10C9.79086 10 8 11.7909 8 14C8 16.2091 9.79086 18 12 18Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Calendar Check Icon -->
    <svg
      v-else-if="name === 'calendar-check'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 2V5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 9H21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 8V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 15L11 17L15 13"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Phone Check Icon -->
    <svg
      v-else-if="name === 'phone-check'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 16.92V19.92C22.0011 20.1986 21.9441 20.4742 21.8325 20.7294C21.7209 20.9846 21.5573 21.2137 21.3521 21.402C21.1468 21.5902 20.9046 21.7336 20.6407 21.8228C20.3769 21.912 20.0974 21.9452 19.82 21.92C16.7428 21.5857 13.787 20.5342 11.19 18.84C8.77382 17.2481 6.72533 15.2003 5.13 12.78C3.42222 10.1733 2.36882 7.20789 2.04 4.13003C2.01488 3.85334 2.04798 3.57463 2.1371 3.3115C2.22622 3.04837 2.36942 2.80673 2.55736 2.60227C2.7453 2.39781 2.97378 2.23511 3.22822 2.12461C3.48266 2.01411 3.75738 1.95828 4.035 1.96003H7.03C7.5637 1.95734 8.07593 2.16653 8.4569 2.54276C8.83787 2.91898 9.0572 3.43199 9.068 3.97103C9.07833 4.6972 9.25337 5.41332 9.58 6.07003C9.70935 6.32758 9.73741 6.62112 9.66041 6.89711C9.5834 7.17311 9.40656 7.41303 9.162 7.57303L7.89 8.84003C9.31278 11.3418 11.4082 13.4373 13.91 14.86L15.18 13.59C15.3393 13.3445 15.5791 13.1668 15.8551 13.0893C16.1312 13.0118 16.425 13.0393 16.683 13.168C17.3413 13.4956 18.0593 13.671 18.787 13.68C19.3271 13.6902 19.8413 13.9095 20.2182 14.2908C20.5951 14.672 20.8047 15.1852 20.802 15.72V16.92H22Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 3L18 5L22 1"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Sparkles Icon -->
    <svg
      v-else-if="name === 'sparkles'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.75C15 7.51142 13.5114 10 10.75 10C13.5114 10 15 12.4886 15 15.25C15 12.4886 16.4886 10 19.25 10C16.4886 10 15 7.51142 15 4.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12.75C8 14.4069 6.40685 16 4.75 16C6.40685 16 8 17.5931 8 19.25C8 17.5931 9.59315 16 11.25 16C9.59315 16 8 14.4069 8 12.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Sparkles 2 Icon (New Design) -->
    <svg
      v-else-if="name === 'sparkles-2'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0585 4.85704L16.9785 7.31038C17.1285 7.71038 17.4418 8.02371 17.8418 8.17371L20.2952 9.09371C20.8618 9.30704 20.8618 10.1137 20.2952 10.327L17.8418 11.247C17.4418 11.397 17.1285 11.7104 16.9785 12.1104L16.0585 14.5637C15.8452 15.1304 15.0385 15.1304 14.8252 14.5637L13.9052 12.1104C13.7552 11.7104 13.4418 11.397 13.0418 11.247L10.5885 10.327C10.0218 10.1137 10.0218 9.30704 10.5885 9.09371L13.0418 8.17371C13.4418 8.02371 13.7552 7.71038 13.9052 7.31038L14.8252 4.85704C15.0385 4.29038 15.8452 4.29038 16.0585 4.85704Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.79828 12.7507L8.25828 13.9774C8.33328 14.1774 8.48995 14.3341 8.68995 14.4091L9.91661 14.8691C10.1999 14.9757 10.1999 15.3791 9.91661 15.4857L8.68995 15.9457C8.48995 16.0207 8.33328 16.1774 8.25828 16.3774L7.79828 17.6041C7.69161 17.8874 7.28828 17.8874 7.18161 17.6041L6.72161 16.3774C6.64661 16.1774 6.48995 16.0207 6.28995 15.9457L5.06328 15.4857C4.77995 15.3791 4.77995 14.9757 5.06328 14.8691L6.28995 14.4091C6.48995 14.3341 6.64661 14.1774 6.72161 13.9774L7.18161 12.7507C7.28828 12.4674 7.69161 12.4674 7.79828 12.7507Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Archive Icon -->
    <svg
      v-else-if="name === 'archive'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 8.75H3.75C3.19772 8.75 2.75 8.30228 2.75 7.75V5.25C2.75 4.69772 3.19772 4.25 3.75 4.25H20.25C20.8023 4.25 21.25 4.69772 21.25 5.25V7.75C21.25 8.30228 20.8023 8.75 20.25 8.75Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 8.75V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H17.25C18.3546 21.25 19.25 20.3546 19.25 19.25V8.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.75 13.25H13.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Archive Arrow Down Icon (Archive) -->
    <svg
      v-else-if="name === 'archive-arrow-down'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 9.75V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H17.25C18.3546 21.25 19.25 20.3546 19.25 19.25V9.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15.25V3.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 12L12 15.25L15.25 12"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.25 6.75H3.75C3.19772 6.75 2.75 6.30228 2.75 5.75V3.25C2.75 2.69772 3.19772 2.25 3.75 2.25H20.25C20.8023 2.25 21.25 2.69772 21.25 3.25V5.75C21.25 6.30228 20.8023 6.75 20.25 6.75Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Archive Arrow Up Icon (Unarchive) -->
    <svg
      v-else-if="name === 'archive-arrow-up'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 13.75V16.25C4.75 17.9069 6.09315 19.25 7.75 19.25H16.25C17.9069 19.25 19.25 17.9069 19.25 16.25V13.75M4.75 13.75V8.75C4.75 7.35212 5.70608 6.17755 7 5.84451M4.75 13.75H9.75V14.25C9.75 15.3546 10.6454 16.25 11.75 16.25H12.25C13.3546 16.25 14.25 15.3546 14.25 14.25V13.75H19.25M19.25 13.75V8.75C19.25 7.35212 18.2939 6.17755 17 5.84451M12 10.25V4.75M12 4.75L9.75 7.25M12 4.75L14.25 7.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Unarchive Icon -->
    <svg
      v-else-if="name === 'unarchive'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 8.75H3.75C3.19772 8.75 2.75 8.30228 2.75 7.75V5.25C2.75 4.69772 3.19772 4.25 3.75 4.25H20.25C20.8023 4.25 21.25 4.69772 21.25 5.25V7.75C21.25 8.30228 20.8023 8.75 20.25 8.75Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 8.75V19.25C4.75 20.3546 5.64543 21.25 6.75 21.25H17.25C18.3546 21.25 19.25 20.3546 19.25 19.25V8.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16.25V11.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 13.25L12 10.25L15 13.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Copy Icon -->
    <svg
      v-else-if="name === 'copy'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="8.75"
        y="8.75"
        width="10.5"
        height="10.5"
        rx="1.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.25 8.75V6.75C15.25 5.64543 14.3546 4.75 13.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V13.25C4.75 14.3546 5.64543 15.25 6.75 15.25H8.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- Circle Dotted Icon -->
    <svg
      v-else-if="name === 'circle-dotted'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-dasharray="1 5"
      />
    </svg>

    <!-- Check Circle Icon -->
    <svg
      v-else-if="name === 'check-circle'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
      />
      <path
        d="M16 9L11 14L8 11"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Cloud Upload Icon -->
    <svg
      v-else-if="name === 'cloud-upload'"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 28.5C12.5 28.5 9.5 28 9.5 24C9.5 20.5738 12.1508 17.7668 15.5134 17.5179C15.7634 13.0478 19.4674 9.5 24 9.5C28.5326 9.5 32.2366 13.0478 32.4866 17.5179C35.8492 17.7668 38.5 20.5738 38.5 24C38.5 28 35.5 28.5 35.5 28.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.5 30.5L24 25.5L19.5 30.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 38.5V27.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Link Icon -->
    <svg
      v-else-if="name === 'link'"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5 26.4999L36 23.9999C39.3137 20.6862 39.3137 15.3136 36 11.9999C32.6863 8.68622 27.3137 8.68622 24 11.9999L21.5 14.4999"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.4999 21.5L11.9999 24C8.68622 27.3137 8.68622 32.6863 11.9999 36C15.3136 39.3137 20.6862 39.3137 23.9999 36L26.4999 33.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.5 19.5L19.5 28.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Pencil Icon -->
    <svg
      v-else-if="name === 'pencil'"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 38.5002L18 36.5002L36.5858 17.9144C37.3668 17.1333 37.3668 15.867 36.5858 15.086L32.9142 11.4144C32.1332 10.6334 30.8668 10.6334 30.0858 11.4144L11.5 30.0002L9.5 38.5002Z"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.5 38.5H27.5"
        :stroke="color || 'currentColor'"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Arrow Right Icon -->
    <svg
      v-else-if="name === 'arrow-right'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12h8.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m13 8 4 4-4 4"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Arrow Left Icon -->
    <svg
      v-else-if="name === 'arrow-left'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12H7.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 16L7 12L11 8"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Hashtag Icon -->
    <svg
      v-else-if="name === 'hashtag'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3L8 21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 3L14 21"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 9H21.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 15H20.5"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Play Icon -->
    <svg
      v-else-if="name === 'play'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.75L18.25 12L8 18.25V5.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Solid Play Icon -->
    <svg
      v-else-if="name === 'play-solid'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 6.2C8.75 5.45 9.57 4.99 10.21 5.38L17.3 9.68C17.93 10.06 17.93 10.94 17.3 11.32L10.21 15.62C9.57 16.01 8.75 15.55 8.75 14.8V6.2Z"
        :fill="color || 'currentColor'"
      />
    </svg>

    <!-- Rocket Icon (Updated from asset) -->
    <svg
      v-else-if="name === 'rocket'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4554 6.8551C14.9311 5.50117 16.861 4.75 18.8637 4.75L19.2499 4.75V5.13613C19.2499 7.13887 18.4987 9.06876 17.1448 10.5445L10.9946 17.2479L6.75195 13.0053L13.4554 6.8551Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.25 16.75L4.75 19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25 18.75L8.75 19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 14.75L4.75 15.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 19.25L14.24 14L11 17.25L13 19.25Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.75 13L10 9.75L4.75 10.75L6.75 13Z"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Alert Circle Icon -->
    <svg
      v-else-if="name === 'alert-circle'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
      />
      <path
        d="M12 8V12"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16H12.01"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- X Circle Icon -->
    <svg
      v-else-if="name === 'x-circle'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
      />
      <path
        d="M9 9L15 15"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 9L9 15"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Trash 2 Icon -->
    <svg
      v-else-if="name === 'trash-2'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H21"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 11V17"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 11V17"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Message Square Icon -->
    <svg
      v-else-if="name === 'message-square'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15C21 16.1046 20.1046 17 19 17H7L3 21V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Translate Icon (View Chat History translate button) -->
    <svg
      v-else-if="name === 'translate'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 19.25L16 12.75L19.25 19.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 17.25H18"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.75 6.75H13.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 6.5V4.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 6.75C11.25 6.75 11.25 9.25 9.25 11.25C7.25 13.25 4.75 13.25 4.75 13.25"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.25 13.25C12.25 13.25 9.75 13.25 7.75 11.25C7.34551 10.8455 6.75 9.75 6.75 9.75"
        :stroke="color || 'currentColor'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Double Chevron Right Icon -->
    <svg
      v-else-if="name === 'double-chevron-right'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 17L18 12L13 7M6 17L11 12L6 7"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Matched Icon -->
    <svg
      v-else-if="name === 'matched'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2502 19.25H6.94974C5.77025 19.25 4.8901 18.2103 5.49106 17.1954C6.36268 15.7234 8.23956 14 12.2502 14"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.75 17.75L16 19.25L19.25 14.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Screened Icon -->
    <svg
      v-else-if="name === 'screened'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 4.75H7.75C6.64543 4.75 5.75 5.64543 5.75 6.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25H11.25M12.75 4.75V8.25C12.75 9.35457 13.6454 10.25 14.75 10.25H18.25M12.75 4.75L18.25 10.25M18.25 10.25V11.25M19.25 14.75C19.25 14.75 17.3214 16.8393 16.3571 19.25L14.75 17.3214"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Interviewed Icon -->
    <svg
      v-else-if="name === 'interviewed'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.89286 4.75H6.06818C5.34017 4.75 4.75 5.34017 4.75 6.06818C4.75 13.3483 10.6517 19.25 17.9318 19.25C18.6598 19.25 19.25 18.6598 19.25 17.9318V15.1071L16.1429 13.0357L14.5317 14.6468C14.2519 14.9267 13.8337 15.0137 13.4821 14.8321C12.8858 14.524 11.9181 13.9452 10.9643 13.0357C9.98768 12.1045 9.41548 11.1011 9.12829 10.494C8.96734 10.1537 9.06052 9.76091 9.32669 9.49474L10.9643 7.85714L8.89286 4.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.75 6.75L16.25 8.25C17 6 19.25 4.75 19.25 4.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Layout Right Icon -->
    <svg
      v-else-if="name === 'layout-right'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74977 4.75L17.25 4.75C18.3546 4.75 19.25 5.64543 19.25 6.75L19.25 17.25C19.25 18.3546 18.3546 19.25 17.25 19.25L6.74977 19.25C5.6452 19.25 4.74977 18.3546 4.74977 17.25L4.74977 6.75C4.74977 5.64543 5.6452 4.75 6.74977 4.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 7.75L15.75 16.25"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Chevron Down Icon -->
    <svg
      v-else-if="name === 'chevron-down'"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 0.75L4 4.25L0.75 0.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- User Circle Check Icon -->
    <svg
      v-else-if="name === 'user-circle-check'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.48798 13.6752L3.02085 14.262L3.48798 13.6752ZM8.25 16C8.66421 16 9 15.6642 9 15.25C9 14.8358 8.66421 14.5 8.25 14.5V15.25V16ZM14.5 8.25C14.5 8.66421 14.8358 9 15.25 9C15.6642 9 16 8.66421 16 8.25H15.25H14.5ZM8.25 12.5C8.66421 12.5 9 12.1642 9 11.75C9 11.3358 8.66421 11 8.25 11V11.75V12.5ZM12.3571 15.25L11.781 15.7301C11.9501 15.9331 12.2136 16.0321 12.4745 15.9908C12.7354 15.9494 12.9554 15.7738 13.0535 15.5285L12.3571 15.25ZM15.8011 11.2587C16.0821 10.9543 16.0631 10.4799 15.7587 10.1989C15.4543 9.91794 14.9799 9.93692 14.6989 10.2413L15.25 10.75L15.8011 11.2587ZM11.3262 12.8413C11.061 12.5231 10.5881 12.4801 10.2699 12.7453C9.95165 13.0104 9.90866 13.4834 10.1738 13.8016L10.75 13.3214L11.3262 12.8413ZM0.75 8H1.5C1.5 4.41021 4.41021 1.5 8 1.5V0.75V0C3.58178 0 0 3.58178 0 8H0.75ZM8 0.75V1.5C11.5898 1.5 14.5 4.41021 14.5 8H15.25H16C16 3.58178 12.4182 0 8 0V0.75ZM10.25 7H9.5C9.5 7.82841 8.82841 8.5 8 8.5V9.25V10C9.65684 10 11 8.65684 11 7H10.25ZM8 9.25V8.5C7.17159 8.5 6.5 7.82841 6.5 7H5.75H5C5 8.65684 6.34316 10 8 10V9.25ZM5.75 7H6.5C6.5 6.17159 7.17159 5.5 8 5.5V4.75V4C6.34316 4 5 5.34316 5 7H5.75ZM8 4.75V5.5C8.82841 5.5 9.5 6.17159 9.5 7H10.25H11C11 5.34316 9.65684 4 8 4V4.75ZM3.48798 13.6752L4.02935 14.1942C5.03134 13.1492 6.43924 12.5 8 12.5V11.75V11C6.01379 11 4.21974 11.8282 2.9466 13.1561L3.48798 13.6752ZM8 15.25V14.5C6.47004 14.5 5.06537 13.9723 3.95511 13.0884L3.48798 13.6752L3.02085 14.262C4.38705 15.3496 6.11861 16 8 16V15.25ZM3.48798 13.6752L3.95511 13.0884C2.45768 11.8963 1.5 10.0602 1.5 8H0.75H0C0 10.5365 1.18134 12.7975 3.02085 14.262L3.48798 13.6752ZM8 15.25V16H8.25V15.25V14.5H8V15.25ZM15.25 8H14.5V8.25H15.25H16V8H15.25ZM8 11.75V12.5H8.25V11.75V11H8V11.75ZM12.3571 15.25L13.0535 15.5285C13.5029 14.4049 14.1863 13.3372 14.7705 12.5389C15.0604 12.1427 15.321 11.8193 15.5082 11.5961C15.6017 11.4846 15.6766 11.3984 15.7274 11.341C15.7527 11.3123 15.772 11.2908 15.7846 11.2769C15.7908 11.27 15.7954 11.265 15.7982 11.2619C15.7996 11.2604 15.8005 11.2594 15.801 11.2588C15.8013 11.2585 15.8014 11.2584 15.8014 11.2584C15.8014 11.2584 15.8014 11.2584 15.8013 11.2585C15.8013 11.2585 15.8013 11.2585 15.8012 11.2586C15.8012 11.2586 15.8011 11.2587 15.25 10.75C14.6989 10.2413 14.6988 10.2414 14.6987 10.2415C14.6987 10.2415 14.6986 10.2416 14.6985 10.2417C14.6983 10.2419 14.6981 10.2421 14.6979 10.2424C14.6974 10.2429 14.6969 10.2435 14.6962 10.2442C14.6948 10.2457 14.693 10.2477 14.6907 10.2502C14.6861 10.2552 14.6798 10.2622 14.6717 10.2712C14.6555 10.2891 14.6324 10.3149 14.6031 10.348C14.5446 10.4142 14.4613 10.5101 14.3589 10.6322C14.1544 10.876 13.8727 11.2256 13.5599 11.6531C12.9387 12.5021 12.1756 13.6844 11.6608 14.9715L12.3571 15.25ZM10.75 13.3214L10.1738 13.8016L11.781 15.7301L12.3571 15.25L12.9333 14.7699L11.3262 12.8413L10.75 13.3214Z"
        :fill="color || 'currentColor'"
      />
    </svg>

    <!-- Users Icon -->
    <svg
      v-else-if="name === 'users'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.78168 15.25H9.21831C9.78281 15.25 10.227 14.7817 10.1145 14.2285C9.80395 12.7012 8.78968 10 5.49999 10C2.21031 10 1.19604 12.7012 0.885477 14.2285C0.772992 14.7817 1.21717 15.25 1.78168 15.25Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.75 10C13.8288 10 14.6802 12.1479 15.0239 13.696C15.2095 14.532 14.5333 15.25 13.6769 15.25H12.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 3.5C8.25 5.01878 7.01878 6.25 5.5 6.25C3.98122 6.25 2.75 5.01878 2.75 3.5C2.75 1.98122 3.98122 0.75 5.5 0.75C7.01878 0.75 8.25 1.98122 8.25 3.5Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.75 6.25C12.2688 6.25 13.25 5.01878 13.25 3.5C13.25 1.98122 12.2688 0.75 10.75 0.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Person Check Icon -->
    <svg
      v-else-if="name === 'person-check'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 2.75L12.25 4.25C13 2 15.25 0.75 15.25 0.75M7.25 3C7.25 4.24264 6.24264 5.25 5 5.25C3.75736 5.25 2.75 4.24264 2.75 3C2.75 1.75736 3.75736 0.75 5 0.75C6.24264 0.75 7.25 1.75736 7.25 3ZM0.75 10.25C0.75 7.5 1.6 5.75 5 5.75C8.4 5.75 9.25 7.5 9.25 10.25H7.25V13.25C7.25 14.3546 6.35457 15.25 5.25 15.25H4.75C3.64543 15.25 2.75 14.3546 2.75 13.25V10.25H0.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Person Cross Icon -->
    <svg
      v-else-if="name === 'person-cross'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 0.75L13.5 2.5M13.5 2.5L15.25 4.25M13.5 2.5L15.25 0.75M13.5 2.5L11.75 4.25M7.25 3C7.25 4.24264 6.24264 5.25 5 5.25C3.75736 5.25 2.75 4.24264 2.75 3C2.75 1.75736 3.75736 0.75 5 0.75C6.24264 0.75 7.25 1.75736 7.25 3ZM0.75 10.25C0.75 7.5 1.6 5.75 5 5.75C8.4 5.75 9.25 7.5 9.25 10.25H7.25V13.25C7.25 14.3546 6.35457 15.25 5.25 15.25H4.75C3.64543 15.25 2.75 14.3546 2.75 13.25V10.25H0.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Users Plus Icon -->
    <svg
      v-else-if="name === 'users-plus'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 10.75V15.25M7.24996 15.25H1.78165C1.21714 15.25 0.772961 14.7817 0.885446 14.2285C1.19601 12.7012 2.21027 10 5.49996 10C6.17443 10 6.75324 10.0563 7.24996 10.25M15.25 13H10.75M10.75 6.25C12.2687 6.25 13.25 5.01878 13.25 3.5C13.25 1.98122 12.2687 0.75 10.75 0.75M8.24996 3.5C8.24996 5.01878 7.01874 6.25 5.49996 6.25C3.98118 6.25 2.74996 5.01878 2.74996 3.5C2.74996 1.98122 3.98118 0.75 5.49996 0.75C7.01874 0.75 8.24996 1.98122 8.24996 3.5Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- User Cross Icon -->
    <svg
      v-else-if="name === 'user-cross'"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 4C11.25 5.79493 9.79493 7.25 8 7.25C6.20507 7.25 4.75 5.79493 4.75 4C4.75 2.20507 6.20507 0.75 8 0.75C9.79493 0.75 11.25 2.20507 11.25 4Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.24997 15.25H2.94949C1.77001 15.25 0.889854 14.2103 1.49082 13.1954C2.36244 11.7234 4.23932 10 8.24997 10"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.25 15.25L11.75 11.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.75 15.25L15.25 11.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Ellipsis Horizontal Icon -->
    <svg
      v-else-if="name === 'ellipsis-horizontal'"
      viewBox="0 0 14 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.58331 0.75C1.25179 0.75 0.933851 0.881694 0.699429 1.11612C0.465007 1.35054 0.333313 1.66848 0.333313 2C0.333313 2.33152 0.465007 2.64946 0.699429 2.88388C0.933851 3.11831 1.25179 3.25 1.58331 3.25C1.91483 3.25 2.23278 3.11831 2.4672 2.88388C2.70162 2.64946 2.83331 2.33152 2.83331 2C2.83331 1.66848 2.70162 1.35054 2.4672 1.11612C2.23278 0.881694 1.91483 0.75 1.58331 0.75Z"
        :fill="color || 'currentColor'"
      />
      <path
        d="M6.1161 1.11612C6.35052 0.881694 6.66846 0.75 6.99998 0.75C7.3315 0.75 7.64944 0.881694 7.88386 1.11612C8.11829 1.35054 8.24998 1.66848 8.24998 2C8.24998 2.33152 8.11829 2.64946 7.88386 2.88388C7.64944 3.11831 7.3315 3.25 6.99998 3.25C6.66846 3.25 6.35052 3.11831 6.1161 2.88388C5.88167 2.64946 5.74998 2.33152 5.74998 2C5.74998 1.66848 5.88167 1.35054 6.1161 1.11612Z"
        :fill="color || 'currentColor'"
      />
      <path
        d="M11.5328 1.11612C11.7672 0.881694 12.0851 0.75 12.4166 0.75C12.7482 0.75 13.0661 0.881694 13.3005 1.11612C13.535 1.35054 13.6666 1.66848 13.6666 2C13.6666 2.33152 13.535 2.64946 13.3005 2.88388C13.0661 3.11831 12.7482 3.25 12.4166 3.25C12.0851 3.25 11.7672 3.11831 11.5328 2.88388C11.2983 2.64946 11.1666 2.33152 11.1666 2C11.1666 1.66848 11.2983 1.35054 11.5328 1.11612Z"
        :fill="color || 'currentColor'"
      />
    </svg>

    <!-- Maximize Icon -->
    <svg
      v-else-if="name === 'maximize'"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.958313 9.29134V13.0413H4.70831M13.0416 4.70801V0.958008H9.29165M1.16665 12.833L5.54165 8.45801M12.8333 1.16634L8.45831 5.54134"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Plus Icon -->
    <svg
      v-else-if="name === 'plus'"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.75V13.25"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.25 7H0.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Chart Increase Icon (trending-up bars) -->
    <svg
      v-else-if="name === 'chart-increase'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 11.25L10.25 5.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.75 19.2502H6.25C6.80229 19.2502 7.25 18.8025 7.25 18.2502V15.75C7.25 15.1977 6.80229 14.75 6.25 14.75H5.75C5.19772 14.75 4.75 15.1977 4.75 15.75V18.2502C4.75 18.8025 5.19772 19.2502 5.75 19.2502Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.75 19.2502H12.25C12.8023 19.2502 13.25 18.8025 13.25 18.2502V12.75C13.25 12.1977 12.8023 11.75 12.25 11.75H11.75C11.1977 11.75 10.75 12.1977 10.75 12.75V18.2502C10.75 18.8025 11.1977 19.2502 11.75 19.2502Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.75 19.2502H18.25C18.8023 19.2502 19.25 18.8025 19.25 18.2502V5.75C19.25 5.19772 18.8023 4.75 18.25 4.75H17.75C17.1977 4.75 16.75 5.19772 16.75 5.75V18.2502C16.75 18.8025 17.1977 19.2502 17.75 19.2502Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 8.25V4.75H7.75"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Folder Star Icon -->
    <svg
      v-else-if="name === 'folder-star'"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V7.75H17.25C18.3546 7.75 19.25 8.64543 19.25 9.75V10.25M13.5 7.75L12.5685 5.7923C12.2181 5.14977 11.5446 4.75 10.8127 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V11M17 12.75C17 14 16 16 14.75 16C16 16 17 18 17 19.25C17 18 18 16 19.25 16C18 16 17 14 17 12.75Z"
        :stroke="color || 'currentColor'"
        :stroke-width="strokeWidth || 1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style scoped>
.icon-atom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-atom svg {
  width: 100%;
  height: 100%;
}
</style>
